<template>
  <v-navigation-drawer fixed app width="250" v-model="leftDrawer">
    <router-link to="/" class="brand-link">
      <v-toolbar :color="headerColor" flat dark class="brand-toolbar">
        <v-img :src="$app.opts.headerLogoSrc" :alt="$app.opts.title" max-height="32" :max-width="logoWidth" contain />
        <v-toolbar-title v-if="showTitle">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
    </router-link>
    <AppNavItems app />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import AppNavItems from './AppNavItems'

export default {
  components: {
    AppNavItems
  },
  computed: {
    ...mapState(NAMESPACE, ['title', 'isLeftDrawerOpened']),
    leftDrawer: {
      get(state) {
        return this.isLeftDrawerOpened
      },
      set(value) {
        this.setLeftDrawerOpened(value)
      }
    },
    headerColor() {
      return [this.$app.opts.headerColor, 'darken-1'].join(' ')
    },
    logoWidth() {
      return this.showTitle ? '32' : ''
    },
    showTitle() {
      return this.$app.opts.showTitle
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['setLeftDrawerOpened'])
  }
}
</script>

<style scoped lang="scss">
.brand-link {
  text-decoration: none;
}

.brand-toolbar {
  &:hover {
    background-color: var(--v-primary-base) !important;
  }
}
</style>
